import React from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Col, Row, Form } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components';
import {
  Box,
  Button,
  FormGroupRow,
  HorizontalFormControl,
} from '../../../../common/components';
import { CheckboxInput } from '../../../../common/components/PublicCheckbox/PublicCheckbox';
import TrackingLinkLabel from '../TrackingLinkLabel/TrackingLinkLabel';
import { required } from 'redux-form-validators';

import './TrackingLinkForm.scss';

const TrackingLinkForm = ({ resource, handleSubmit, submitting, onSave, formValues }) => {
  const resourceAttributes = resource?.data?.attributes ?? {};
  const { name, status } = resourceAttributes;
  const boolToBrokerType = (boolValue) => (boolValue ? 'tracking' : 'introducer');
  const brokerTypeToBool = (brokerType) => brokerType === 'tracking';

  const isInsuranceQuestionsEnabled =
    formValues?.data?.attributes?.metadata?.insurance_marketing_options_enabled;

  const showInsuranceQuestions =
    formValues?.data?.attributes?.broker_type !== 'introducer';

  return (
    <Box className={'tracking-link-form'}>
      <h2 className="resource-name">
        <TrackingLinkLabel status={status || ''} name={name || 'New Tracking Link'} />
      </h2>
      <Form horizontal onSubmit={handleSubmit(onSave)} className="broker-form">
        <Row>
          <Col sm={6}>
            <Field
              name="data.attributes.trading_name"
              label="Name"
              labelSize={4}
              component={HorizontalFormControl}
              validate={required({ msg: 'name is required' })}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Field
              name="data.attributes.metadata.display_phone_number"
              label="Display Number"
              labelSize={4}
              object
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        {!resource.data.id && (
          <FormGroupRow>
            <div className={'tracking-link-form--broker-type-checkbox'}>
              <div className={'tracking-link-form--label'}>Tracking link only</div>
              <Field
                name="data.attributes.broker_type"
                parse={boolToBrokerType}
                format={brokerTypeToBool}
                component={CheckboxInput}
              />
            </div>
          </FormGroupRow>
        )}

        <FormGroupRow>
          <div className={'tracking-link-form--broker-type-checkbox'}>
            <div className={'tracking-link-form--label'}>Enable Renewals</div>
            <Field
              name="data.attributes.metadata.renewals_enabled"
              component={CheckboxInput}
            />
          </div>
        </FormGroupRow>

        <FormGroupRow>
          <div className={'tracking-link-form--broker-type-checkbox'}>
            <div className={'tracking-link-form--label'}>Enable Sales Banner</div>
            <Field
              name="data.attributes.metadata.sales_banner_enabled"
              component={CheckboxInput}
            />
          </div>
        </FormGroupRow>

        {showInsuranceQuestions && (
          <>
            <FormGroupRow>
              <div className={'tracking-link-form--broker-type-checkbox'}>
                <div className={'tracking-link-form--label'}>
                  Enable Insurance Questions
                </div>
                <Field
                  name="data.attributes.metadata.insurance_marketing_options_enabled"
                  component={CheckboxInput}
                />
              </div>
            </FormGroupRow>
            {isInsuranceQuestionsEnabled && (
              <>
                <FormGroupRow>
                  <div className={'tracking-link-form--broker-type-checkbox'}>
                    <div className={'tracking-link-form--label'}>
                      Enable Home Insurance Question
                    </div>
                    <Field
                      name="data.attributes.metadata.home_insurance_marketing_enabled"
                      component={CheckboxInput}
                    />
                  </div>
                </FormGroupRow>
                <FormGroupRow>
                  <div className={'tracking-link-form--broker-type-checkbox'}>
                    <div className={'tracking-link-form--label'}>
                      Enable Car Insurance Question
                    </div>
                    <Field
                      name="data.attributes.metadata.car_insurance_marketing_enabled"
                      component={CheckboxInput}
                    />
                  </div>
                </FormGroupRow>
              </>
            )}
          </>
        )}
        <FormGroupRow>
          <div className={'tracking-link-form--broker-type-checkbox'}>
            <div className={'tracking-link-form--label'}>Can use data for marketing</div>
            <Field
              name="data.attributes.metadata.allow_marketing"
              component={CheckboxInput}
            />
          </div>
        </FormGroupRow>

        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['broker.edit'],
                  button: (
                    <Button
                      className="pull-right"
                      type="submit"
                      bsStyle="primary"
                      label={'Save Tracking Link'}
                      isLoading={submitting}
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </Form>
    </Box>
  );
};

const FORM_NAME = 'TrackingLinkForm';
export default connect((state, ownProps) => ({
  initialValues: ownProps.resource,
  formValues: getFormValues(FORM_NAME)(state),
}))(reduxForm({ form: FORM_NAME })(TrackingLinkForm));
